
export function objToParams(obj = {}, s = '?') {
  return Object.keys(obj).reduce(
    (str, key, index) =>
      (str += (index === 0 ? s : '&') + key + '=' + obj[key]),
    ''
  )
}

export const arrToOptions = (arr) =>
  arr.map((item) => ({ label: item, value: item }))

export const objToOptions = (obj) =>
  Object.entries(obj).map((item) => ({ value: item[0], label: item[1] }))

export const arrToObj = (arr) =>
  arr.reduce((obj, key) => ({ ...obj, [key]: '' }), {})

export const filterArr = (arr1, arr2) =>
  arr1.filter((item) => !arr2.includes(item))

export const uniqBy = (arr = [], key) => [
  ...new Map(arr.map((item) => [item[key], item])).values()
]

export const getValue = (obj, v = 'inputValue') =>
  Object.keys(obj).reduce((o, key) => ({ ...o, [key]: obj[key][v] }), {})

export const getLabel = (obj) =>
  obj.options.filter((item) => item.value === obj.inputValue)[0]?.label ||
  obj.inputValue

export const getTableLabel = (arr, key) =>
  arr.find((item) => item.prop === key).label

export const arrToObjByKey = (arr = [], key) =>
  arr.reduce(
    (obj, item) => ({
      [item[key]]: obj[item[key]] ? obj[item[key]].push(item) : [item],
      ...obj
    }),
    {}
  )

export class Cache {
  constructor(vm, option = {}) {
    this.option = option
    this.cache = new Map()
    this.vm = vm
  }
  hash(para) {
    return JSON.stringify(para)
  }
  api(fetchName, para) {
    const cacheName = fetchName + this.hash(para)
    return new Promise((resole, reject) => {
      if (this.cache.has(cacheName)) {
        return resole({ data: this.cache.get(cacheName) })
      }

      if (!this.option.api) {
        console.error('请传入api对象')
        return
      } else if (typeof this.option.api[fetchName] === 'function') {
        this.option.api[fetchName](para).then(res => {
          this.cache.set(cacheName, res)
          return resole({ data: res })
        }).catch(err => {
          console.error(err)
          return reject(err)
        })
      }
    })
  }
}

export function thousands(num) {
  num = Number(num).toFixed(2);//保留两位小数
  var str = num.toString();
  var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, "$1,")
}

export function antiThousands(string) {
  let str = ''
  if (string) {
    str = String(string).replace(/,/g, "")
  }
  return Number(str).toFixed(2)
}

export function timeFormat(time) {
  return time == '0000-00-00' || time == '0000-00-00 00:00:00' ? '' : time
}

export function limitInput(value) {
  // 第一步：转成字符串
  // 第二步：把不是数字，不是小数点的过滤掉
  // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
  // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
  // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
  return value.toString().replace(/[^\d^.]+/g, "").replace(/^0+(\d)/, "$1").replace(/^\./, "0.").match(/^\d*(\.?\d{0,2})/g)[0] || " ";
}
